import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/shareIcons/stethoscope.svg'
import _imports_1 from '@/assets/images/shareIcons/arrow-right.svg'
import _imports_2 from '@/assets/images/shareIcons/list_dash.svg'
import _imports_3 from '@/assets/images/shareIcons/doc.svg'
import _imports_4 from '@/assets/images/consultations/brush.svg'
import _imports_5 from '@/assets/images/consultations/paperclip.svg'
import _imports_6 from '@/assets/images/consultations/sparkles.svg'


const _hoisted_1 = {
  key: 1,
  class: "container-view"
}
const _hoisted_2 = { class: "left-column" }
const _hoisted_3 = { class: "header-column row" }
const _hoisted_4 = { class: "header-column-left row gap-06" }
const _hoisted_5 = { class: "bg-modal" }
const _hoisted_6 = { class: "grid w-full" }
const _hoisted_7 = { class: "overflow" }
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "cslist-left"
}
const _hoisted_10 = {
  key: 1,
  class: "cslist-left pright-3px"
}
const _hoisted_11 = { class: "cslist-right" }
const _hoisted_12 = { class: "line-container" }
const _hoisted_13 = { class: "center-text" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "font-m font-bold-600 txt-grey-40" }
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = {
  key: 0,
  src: _imports_1,
  class: "square-12 img-grey-dark"
}
const _hoisted_18 = { class: "avatar-circle font-size-12" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "capitalize" }
const _hoisted_21 = { class: "headerDay" }
const _hoisted_22 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "col grid"
}
const _hoisted_25 = {
  class: "row es-conclusion mleft-04",
  style: {"margin-bottom":"0"}
}
const _hoisted_26 = {
  key: 1,
  class: "flex-square-24"
}
const _hoisted_27 = { class: "grid" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = {
  key: 0,
  class: "row-top w-full"
}
const _hoisted_31 = {
  style: {"position":"relative"},
  class: "row w-full mright-03"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  style: {"margin":"0rem 0.8rem 0rem auto","max-width":"20rem"},
  class: "row"
}
const _hoisted_34 = ["id", "onDragover", "onDragleave", "onDrop"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "row-top w-full"
}
const _hoisted_37 = { class: "group-item3" }
const _hoisted_38 = {
  class: "w-full row flex-start",
  style: {"position":"relative"}
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["uiId", "onDragstart"]
const _hoisted_42 = {
  key: 1,
  center: true,
  src: _imports_3,
  class: "filter-grey square-14 mtop-02"
}
const _hoisted_43 = { class: "w-full line-item row" }
const _hoisted_44 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem"}
}
const _hoisted_45 = { class: "mleft-08 linebreak text font-m flex-wrap" }
const _hoisted_46 = {
  key: 0,
  class: "recognize-text"
}
const _hoisted_47 = {
  key: 0,
  class: "colCenter"
}
const _hoisted_48 = { class: "h4" }
const _hoisted_49 = {
  key: 1,
  class: "colCenter mtop-60"
}
const _hoisted_50 = { class: "h4 mtop-06 txt-grey-40" }
const _hoisted_51 = { class: "right-column" }

import { ref, reactive, computed, watch, nextTick, onMounted, onUnmounted } from 'vue';
import lBarFilters from './lBarFilters.vue';
import lBarHeaderFilters from './lBarHeaderFilters.vue';
import showAnnotations from '../showAnnotations.vue';
import groupCcl from './groupCcl.vue';
import loadingSpinner from '@/views/loadingSpinner.vue';
import middleColumn from '../middleColumn/middleColumn.vue';
import loadingScreen from '@/views/loadingScreen.vue';
import lBarChangeCsDate from '@/views/patientMain/leftBar/lBarChangeCsDate.vue';
import EsButtonIcon from '@/components/esButtonIcon.vue';
import rBarMoreMenu from '@/views/patientMain/rightBar/rBarMoreMenu.vue';
import editExpressionHistory from '../editExpressionHistory.vue';
import {useDebounceFn} from '@vueuse/core';
import {useCurrentEntryStore} from '@/stores/currentEntry';
import {useUiStore} from '@/stores/ui';
import { useRoute } from 'vue-router'
import {
  sortArrayByOrderNumber,
  getTextBasedOnLanguage,
  findById,
  isForeignLang
} from '@/functions/expression';
import gen from '@/functions/general.js';
import patientapi from '@/api/patientapi';
import { useAppUserStore } from '@/stores/appUser';
import TextItem from '@/items/textItem.vue';
import EsConsultationTopBar from '@/views/patientMain/consultations/esConsultationTopbar.vue';
import EsConsultationDetails from '@/views/patientMain/consultations/esConsultationDetails.vue';
import { format, differenceInMinutes, parseISO } from 'date-fns';
import DateService from '@/services/DateService';
import StringService from "@/services/StringService";
import { formatUTCDateTimeToDate, formatUTCDateTimeToTime, getLocaleForDateFns } from '@/utils/date-utils';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { useI18n } from 'vue-i18n';
import EsSelectHealthProDelegateModal from '@/components/modals/patient/esSelectHealthProDelegateModal.vue';
import { ApiError, CheckArchiveResponse, FolderPatientApi, GetConsultationsRequest, PersonLightResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config'
import { isHealthPro, isAssistantOrHealthProStudent } from '@/utils/role-utils';
import { getLocaleForJs } from '@/utils/date-utils';
import appuserapi from "@/api/appuserapi";
import EsConfirmDialog from "@/components/modals/esConfirmDialog.vue";
import EsPatientActionMenu from "@/components/patient/esPatientActionMenu.vue";
import PersonService from "@/services/PersonService";
import { DateFormat } from '@/models/share.model';

const size = 10;

const declassified = "Déclassés";


export default /*@__PURE__*/_defineComponent({
  __name: 'lBarCs',
  emits: ['changeShowRightBar', 'close', 'loadingCommonConcept', 'reloadPatientData'],
  setup(__props, { emit: __emit }) {

const local = computed(() => {
  return getLocaleForDateFns(appUserStore?.currentAppUserData?.preferences?.menuLanguageIso);
});

const localeForJs = computed(() =>
    getLocaleForJs(appUserStore?.currentAppUserData?.preferences?.menuLanguageIso)
);


const route = useRoute();

const folderPatientApi = new FolderPatientApi(medServerApiConfig);


const appUserStore = useAppUserStore();
const currentEntryStore = useCurrentEntryStore();
const openSelectHealthProDelegate = ref<boolean>(false);

let observer: IntersectionObserver = null;
const infiniteScrollTrigger = ref<Element>(null);
const csListLoading = ref<boolean>(false);
const canLoadMoreCs = ref<boolean>(true);
const page = ref<number>(0);
const delegateId = ref<string>(undefined);
const uiStore = useUiStore();
const toast = useToast();
const { t } = useI18n();

const templateDocArr = ref([]);
const sapExprArr = ref([]);
const addedNewGroup = ref(false);
const init = ref(false);

const isArchiveRestoreModalOpen = ref<boolean>(false);
const entryIdToArchiveRestore = ref<string>(undefined);
const confirmMessage = ref<string>(undefined);
const confirmHeader = ref<string>(undefined);
const archiveRestoreValidationMessage = ref<string>(undefined);
const archiveNotAllowed = ref<boolean>(false);

// ===== BACKGROUND SAVE QUEUE =====
let pendingWork: Promise<void> = Promise.resolve();
const finalUpdateIndex = new Map();
let lastSaveFailedToastAt = 0;
let pendingOps = 0;

function enqueue(task: () => Promise<void> | void, label: string): void {
  pendingOps++;
  pendingWork = pendingWork
    .then(task)
    .catch(err => console.error(`pendingWork chain error (${label}):`, err))
    .finally(() => { pendingOps--; });
}

function notifySaveFailed() {
  const now = Date.now();
  if (now - lastSaveFailedToastAt < 3000) return;   // dedupe a burst of failures
  lastSaveFailedToastAt = now;
  toastError(toast, {
    summary: t('common.toast.error'),
    detail: t('error.EXPRESSION_SAVE_FAILED'),
    life: 0,
  });
}

function captureUpdatePayload() {
  const item3 = currentResultLocal.value;
  if (!item3 || item3.text === item3.dbText) return null;
  return { item2: currentCclLocal.value, item3 };
}

async function commitPendingEdits() {
  updateExpr();              // enqueue the current row's unsaved text (no-op if clean)
  await pendingWork;         // then drain the whole chain
}

function enqueueFinalUpdate(item2) {
  if (!item2) return;
  const cclId = item2.conclusionGroupId;
  const myIndex = (finalUpdateIndex.get(cclId) ?? 0) + 1;
  finalUpdateIndex.set(cclId, myIndex);
  enqueue(() => {
    if (finalUpdateIndex.get(cclId) !== myIndex) return;   // superseded: a newer update will run
    finalUpdateIndex.delete(cclId);
    if (item2.groupOrder === -1) return;
    currentEntryStore.updateCclSuggestionsForResults(cclId.toString());
    updateRootGroup(item2);
  }, "finalUpdate");
}

function onBeforeUnload(e: BeforeUnloadEvent) {
  const item3 = currentResultLocal.value;
  const hasUnsavedText = item3 && item3.text !== item3.dbText;
  if (pendingOps > 0 || hasUnsavedText) {
    e.preventDefault();
    e.returnValue = '';     // required by Chrome for the native "leave site?" prompt
  }
}

// ====================

const currentCsLocal = computed(() => {
  const id = currentEntryStore.currentCsId
  if (!id || !currentEntryStore.csList) return null
  return currentEntryStore.csList.find((cs: any) => cs.relationshipId === id)
})

const currentCclLocal = computed(() => {
  if (!currentCsLocal.value) return null
  const id = currentEntryStore.currentCclId
  if (!id) return null
  return currentCsLocal.value.conclusionGroups?.find(
    (ccl: any) => ccl.conclusionGroupId === id
  )
})

const currentResultLocal = computed(() => {
  if (!currentCclLocal.value) return null
  const id = currentEntryStore.currentResultId
  if (!id) return null
  return currentCclLocal.value.resultsArr?.find(
    (r: any) => r.expressionCclId === id
  )
})

const currentUserPwr  = computed(() =>
  appUserStore.currentAppUserData?.healthGroupMemberships?.[0]?.pwr ?? null
)
const isCurrentUserHealthPro = computed(() =>
  isHealthPro(currentUserPwr.value?.personRoleType)
)

const isCurrentUserAssistantOrStudent = computed(() =>
  isAssistantOrHealthProStudent(currentUserPwr.value?.personRoleType)
)

function isOutsideCooldown(entryDate: string) {
  const cooldownMinutes = 60;
  const minutesSinceEntry = differenceInMinutes(new Date(), parseISO(entryDate));
  return minutesSinceEntry > cooldownMinutes;
}

const showCreateNewEntryButton = computed(() => {
  if (!currentEntryStore.hasCurrentEntry) return true
  if (!currentEntryStore.isEditable  || currentEntryStore.currentEntry.archivedByUser) return true
  if (isCurrentUserAssistantOrStudent.value) return true
  return isOutsideCooldown(currentEntryStore.currentEntryDate)
})

const emits = __emit;

// ===== ROW LIFECYCLE ==========
let tempUiIndex = 0;

function buildRowBase(topUiRef, text = "") {
  const tempIndex = ++tempUiIndex;
  return {
    id: gen.newId("lBarOriginalTextTemp", tempIndex),
    text,
    dbText: "",
    expressionId: null,
    expressionCclId: null,
    topUi: topUiRef,
    buttonText: "",
    buttonMatched: false,
    resultDocument: "",
  }
}

function createLocalRow() {
  const item3 = currentResultLocal.value;
  const row = buildRowBase(item3.id.ui);
  row.expressionCclId = `local-${row.id.ui}`;
  row._isLocalOnly = true;
  row._insertAfterRef = item3;
  row._error = false;
  return row;
}

async function createTempRow(text = "") {
  const item3 = currentResultLocal.value;
  const respJson = await patientapi.addResultAfterCurrent(
    item3.expressionCclId, text, currentEntryStore.currentEntryId
  );
  const row = buildRowBase(item3.id.ui, text);
  row.expressionCclId = respJson.expressionCclId;
  row.expressionId = respJson.expressionId;
  return row;
}

async function persistLocalRow(localRow) {
  if (localRow._error) return;
  let predecessor = localRow._insertAfterRef;
  while (predecessor && predecessor._isLocalOnly) {
    predecessor = predecessor._insertAfterRef;
  }
  if (!predecessor?.expressionCclId) {
    localRow._error = true;
    throw new Error("No persisted ancestor found for local row");
  }
  try {
    const sentText = localRow.text;
    const resp = await patientapi.addResultAfterCurrent(
      predecessor.expressionCclId,
      sentText,
      currentEntryStore.currentEntryId
    );
    // Row was deleted while the create was in flight → undo it server-side
    if (localRow._error) {
      try {
        await patientapi.deleteExpression(
          resp.expressionCclId, currentEntryStore.currentEntryId, undefined
        );
      } catch (err) {
        console.error("Compensating delete failed, orphan row possible:", err);
      }
      return;
    }
    const oldLocalId = localRow.expressionCclId;
    localRow.expressionCclId = resp.expressionCclId;
    localRow.expressionId = resp.expressionId;
    localRow._isLocalOnly = false;
    // NOTE: deliberately do NOT set dbText here. The create doesn't return the
    // matched concept, so we leave dbText as "" and let saveRow's
    // updateExpressionText fetch + apply the interpretation.
    if (currentEntryStore.currentResultId === oldLocalId) {
      currentEntryStore.setCurrentResult(localRow);
    }
  } catch (err) {
    localRow._error = true;
    throw err;
  }
}

async function saveRow(pendingUpdate) {
  if (!pendingUpdate || pendingUpdate.item3._error) return;
  const item3 = pendingUpdate.item3;
  // New row: create it first. If the create fails it never reached the DB,
  // so reflect the DB by removing the optimistic row from the UI.
  const wasLocal = item3._isLocalOnly;
  if (wasLocal) {
    try {
      await persistLocalRow(item3);
    } catch (err) {
      console.error("Create failed, removing optimistic row:", err)
      const wasCurrent = currentEntryStore.currentResultId === item3.expressionCclId;
      const predecessor = item3._insertAfterRef;
      removeFromLocalArray(item3, pendingUpdate.item2);
      removeRowAndMaybeGroup(pendingUpdate.item2, item3);
      if (wasCurrent && predecessor) currentEntryStore.setCurrentResult(predecessor)
      notifySaveFailed();
      return;
    }
  }
  const textToSave = item3.text;
  if (textToSave === item3.dbText) return;
  const expressionCclId = item3.expressionCclId
  if (typeof expressionCclId === 'string' && expressionCclId.startsWith('local-')) {
    // Invariant violation, not a transport error: log, don't toast.
    console.error(`Refusing to save with local ID: ${expressionCclId}`);
    return;
  }
  const prevDbText = item3.dbText;
  let updatedExpr;
  try {
    updatedExpr = await patientapi.updateExpressionText(
      expressionCclId, textToSave, currentEntryStore.currentEntryId
    )
  } catch (err) {
    console.error("Text save failed:", err);
    // Existing row whose new text never persisted -> revert to last-saved value,
    // but only if the user hasn't typed more since this save was issued.
    // A just-created row (wasLocal) already persisted `textToSave` via the create,
    // so we must NOT wipe it — only the interpretation refresh was lost.
    if (!wasLocal && item3.text === textToSave) {
      item3.text = prevDbText;
      item3.buttonText = prevDbText;
    }
    notifySaveFailed();
    return;
  }
  currentEntryStore.updateExpression(updatedExpr)
  if (prevDbText && prevDbText !== "") {
    currentEntryStore.setReloadSummaryData(true);
    currentEntryStore.setReloadTreatmentData(true);
  }
  if (currentResultLocal.value === item3) {
    applyServerResponse(updatedExpr, item3)
  } else {
    item3._pendingResponse = { updatedExpr, item2: pendingUpdate.item2 }
    const sctLanguage = appUserStore?.currentAppUserData?.preferences?.sctLanguage
    item3.buttonText = getTextBasedOnLanguage(updatedExpr, sctLanguage);
    item3.buttonMatched = updatedExpr.isMatched;
  }
  if (item3.text === textToSave) {
    item3.dbText = updatedExpr.originalText;
  }
}

function applyServerResponse(updatedExpr, item3) {
  const sctLanguage = appUserStore?.currentAppUserData?.preferences?.sctLanguage;
  updatedExpr.id = item3.id;
  item3.expression = updatedExpr;
  item3.buttonText = getTextBasedOnLanguage(updatedExpr, sctLanguage);
  item3.buttonMatched = updatedExpr.isMatched;
  // dbText is intentionally NOT updated here — saveRow does it, guarded by
  // `item3.text === textToSave` (last-write-wins while the user keeps typing).
}

function flushPendingResponse(item3) {
  if (!item3?._pendingResponse) return;
  const { updatedExpr } = item3._pendingResponse;
  delete item3._pendingResponse;
  applyServerResponse(updatedExpr, item3);
}
// ===== ROW REMOVAL ==========
function removeRowAndMaybeGroup(item2, item3) {
  const cs = getCurrentCs();
  const before = item2.resultsArr.length;
  item2.resultsArr = item2.resultsArr.filter(r => r !== item3);
  if (item2.resultsArr.length < before && cs) {   // only if this call actually removed it
    cs.rows--;
  }
  // Re-link rows that anchored on the removed row
  item2.resultsArr.forEach(row => {
    if (row._insertAfterRef === item3) {
      row._insertAfterRef = item3._insertAfterRef
        ?? item2.resultsArr.find(r => r.id.ui === item3.topUi)
        ?? null;
    }
  });
  const wasLast = item2.resultsArr.length === 0;
  if (wasLast && cs &&
      (item2.groupText === declassified || (isCclDeletable(item2) && item2.groupOrder > 1))) {
    cs.conclusionGroups = cs.conclusionGroups.filter(g => g !== item2);
  }
}

function removeFromLocalArray(item3, item2 = currentCclLocal.value) {
  if (!item2?.resultsArr) return;
  const index = item2.resultsArr.indexOf(item3);
  if (index > -1) {
    item2.resultsArr.splice(index, 1);
    const cs = getCurrentCs();
    if (cs) cs.rows--;
  }
  // Re-link any row that used this one as its predecessor.
  item2.resultsArr.forEach(row => {
    if (row._insertAfterRef === item3) {
      row._insertAfterRef = item3._insertAfterRef;
    }
  })
}

function restoreRow(item2, item3) {
  const cs = getCurrentCs();
  // Group was optimistically removed too? Put it back.
  if (cs && !cs.conclusionGroups.includes(item2)) {
    cs.conclusionGroups.push(item2);
    sortArrayByOrderNumber(cs.conclusionGroups, "row");
  }
  if (!item2.resultsArr.includes(item3)) {
    item2.resultsArr.push(item3);
    sortArrayByOrderNumber(item2.resultsArr, "row");
    if (cs) cs.rows++;
  }
}

// =========================

async function setCurrentResultInput(item1: any, item2: any, item3: any) {
  currentEntryStore.setMiddleTab('resultSuggestions');
  if (item3 !== currentResultLocal.value) {
    // Flush the row we're leaving before switching (optimistic model)
    updateExpr(currentResultLocal.value);
    setSelection(item1, item2, item3);
    currentEntryStore.clearBodyParts();
    syncBodyParts(item3.text);
  }
}

async function textInputFct(item3) {
  currentEntryStore.setCurrentResult(item3)
  syncBodyParts(item3.text)
  debouncedUpdateExpr()
}

const debouncedUpdateExpr = useDebounceFn(() => {
  updateExpr();
}, 250);

function updateExpr(blurredItem3 = null) {
  const item3 = blurredItem3 || currentResultLocal.value;
  if (!item3) return;
  flushPendingResponse(item3);
  const needsPersist = item3._isLocalOnly;
  const needsSave = item3.text !== item3.dbText;
  if (!needsPersist && !needsSave) return;
  const item2 = currentCclLocal.value;
  // Optimistic: typed text on the proxy button
  item3.buttonText = item3.text;
  enqueue(async () => {
    if (item3._error) return;
    await saveRow({ item2, item3 });
  }, "updateExpr");
  enqueueFinalUpdate(item2);
}

function deleteFct(item2: any, item3: any) {
  if (item3._isLocalOnly) {
    item3._error = true;   // cancels any queued persist
    const rowAbove = item2.resultsArr.find(r => r.id.ui === item3.topUi);
    if (rowAbove) currentEntryStore.setCurrentResult(rowAbove);
    removeFromLocalArray(item3);
    removeRowAndMaybeGroup(item2, item3);
    focusElement(item3.topUi);
    enqueueFinalUpdate(item2);
    return;
  }
  const entryId = currentEntryStore.currentEntryId;
  const expression_CclId = item3.expressionCclId
  const topUi = item3.topUi;
  const isLastExpressionOfCcl = (item2.resultsArr.length <= 1)
  dropd.value = "";
  //Don't delete last expression of ccl 1
  if (isLastExpressionOfCcl && (!isCclDeletable(item2)  || item2.groupOrder === 1)) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.DELETE_FORBIDDEN_LAST_ITEM`)
    });
    return;
  }
  // Point selection at the row above BEFORE removing
  const rowAbove = item2.resultsArr.find(r => r.id.ui === topUi);
  if (rowAbove) currentEntryStore.setCurrentResult(rowAbove);
  // Optimistic removal
  removeRowAndMaybeGroup(item2, item3);
  focusElement(topUi);
  // Background delete via the chain
  enqueue(async () => {
    try {
      await patientapi.deleteExpression(expression_CclId, entryId, undefined);
      currentEntryStore.setReloadSummaryData(true);
      currentEntryStore.setReloadTreatmentData(true);
    } catch (error) {
      restoreRow(item2, item3);   // UI must match the DB: the row still exists
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
      });
    }
  }, "delete");
  enqueueFinalUpdate(item2);
}

function handleTabToNext(item2) {
  currentEntryStore.setConclusionIdToFocus(item2.conclusionGroupId)
}

async function backSpaceFct(event) {
  let item2 = currentCclLocal.value;
  const item3 = currentResultLocal.value;
  // Local-only empty row: drop it, cancel any queued persist
  if (item3._isLocalOnly && item3.text === "") {
    item3._error = true;
    const rowAbove = item2.resultsArr.find(r => r.id.ui === item3.topUi);
    removeFromLocalArray(item3);
    removeRowAndMaybeGroup(item2, item3);
    if (rowAbove) currentEntryStore.setCurrentResult(rowAbove);
    focusElement(item3.topUi);
    enqueueFinalUpdate(item2);
    return;
  }
  const newText = item3.text
  if (newText) {return;}
  const expr = findById(currentEntryStore.allExpressions, "expressionId", item3.expressionId)
  if (expr && expr.expressionType !== 'None') return;
  event.preventDefault()
  const entryId = currentEntryStore.currentEntryId;
  const expression_CclId = item3.expressionCclId
  const topUi = item3.topUi
  const isLastExpressionOfCcl = (item2.resultsArr.length <= 1)
  //Don't delete last expression of ccl 1
  if (isLastExpressionOfCcl && (!isCclDeletable(item2) || item2.groupOrder === 1)) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.DELETE_FORBIDDEN_LAST_ITEM`)
    });
    return;
  }
  // Find the row above BEFORE deleting
  const rowAbove = item2.resultsArr.find(r => r.id.ui === topUi)
  // Optimistic removal (+ group cleanup if now empty)
  removeRowAndMaybeGroup(item2, item3);
  if (rowAbove) currentEntryStore.setCurrentResult(rowAbove);
  focusElement(topUi, null);
  // Background delete via the chain
  enqueue(async () => {
    try {
      await patientapi.deleteExpression(expression_CclId, entryId, undefined);
    } catch (error) {
      restoreRow(item2, item3);
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
      });
    }
  }, "backspace delete");
  enqueueFinalUpdate(item2);
}

function addBlankRow() {
  const pendingUpdate = captureUpdatePayload();
  const newExpr_ccl = createLocalRow();
  const newGroup = currentCclLocal.value;
  addRowBelow(newExpr_ccl);
  currentEntryStore.setCurrentResult(newExpr_ccl);
  nextTick(() => focusElement(newExpr_ccl.id.ui));
  enqueue(async () => {
    await saveRow(pendingUpdate);                          // flush old row's text
    await saveRow({ item2: newGroup, item3: newExpr_ccl }); // persist the new row (via _isLocalOnly)
  }, "addBlankRow");
  if (pendingUpdate) enqueueFinalUpdate(pendingUpdate.item2);
}


async function addSuggestionRow() {
  if (!currentEntryStore.newEntryText) return;
  //Save values and reset
  const newEntryText = currentEntryStore.newEntryText
  const newEntryUnit = currentEntryStore.newEntryUnit
  currentEntryStore.setNewEntryText('')
  currentEntryStore.setNewEntryUnit('')
  //Logic
  let part1 = newEntryText
  let part2 = ""
  if (newEntryUnit) {
    part1 += " "
    part2 = " " + newEntryUnit
  }
  const focusIndex = part1.length
  //Call
  const item3 = currentResultLocal.value
  if (item3.text === '') {
    const newText = part1 + part2
    item3.text = newText
    item3.buttonText = newText
    focusElement(item3.id.ui, focusIndex)
  } else {
    const pendingUpdate = captureUpdatePayload();      // unsaved text on the row we're leaving
    const newText = part1 + part2;
    const newGroup = currentCclLocal.value;
    // Optimistic: create local row and show it immediately
    const newExpr_ccl = createLocalRow();              // reads current row for _insertAfterRef
    newExpr_ccl.text = newText;
    newExpr_ccl.buttonText = newEntryText;
    addRowBelow(newExpr_ccl);                          // reads current row for ordering
    currentEntryStore.setCurrentResult(newExpr_ccl);
    focusElement(newExpr_ccl.id.ui, focusIndex);
    // Background: persist old row, then create + interpret the new row
    enqueue(async () => {
      await saveRow(pendingUpdate);
      await saveRow({ item2: newGroup, item3: newExpr_ccl });
    }, "addSuggestionRow");
    if (pendingUpdate) enqueueFinalUpdate(pendingUpdate.item2);
    enqueueFinalUpdate(newGroup);
  }
}

function addRowBelow(newExpr_ccl) {
  const item1 = getCurrentCs();
  const item2 = currentCclLocal.value;
  const item3 = currentResultLocal.value;
  if (!item1 || !item2 || !item3) return;
  const oldRowOrder = item3.row           //e.g. row 4

  //Adapt row count + row uiOrder
  item1.rows++
  item1.conclusionGroups.forEach(ccl => {
    if (ccl.row > oldRowOrder) {
      ccl.row = ccl.row + 1;
    }
    if (!ccl.resultsArr) {return;}
    ccl.resultsArr.forEach(expr_ccl => {
      if (expr_ccl.row > oldRowOrder) {     //e.g. row 5, 6, 7 --> 6, 7, 8
        expr_ccl.row = expr_ccl.row + 1
      }
    })
  })

  //Add new row and sort
  newExpr_ccl.row = oldRowOrder + 1         //e.g. row 5
  item2.resultsArr.push(newExpr_ccl)
  sortArrayByOrderNumber(item2.resultsArr, "row")
}

function focusOnLastExpr(conclusionGroupId = null) {
  const cs = getCurrentCs();
  const cclGroups = cs?.conclusionGroups;
  if (!cclGroups?.length) return;

  const targetCclGroup = conclusionGroupId
    ? cclGroups.find(ccl => ccl.conclusionGroupId === conclusionGroupId)
    : cclGroups.at(-1);
  if (!targetCclGroup?.resultsArr?.length) return;

  const lastExpr = targetCclGroup.resultsArr.at(-1);
  setSelection(cs, targetCclGroup, lastExpr);
  focusElement(lastExpr.id.ui);
  addedNewGroup.value = false;
}

function focusElement(uiId, focusIndex = 0) {
  if (!uiId) return;
  setTimeout(() => {
    const inputElement = inputRefs.value[uiId];
    if (!inputElement) return;
    inputElement.innerRef.focus();
    if (!focusIndex) focusIndex = currentResultLocal.value?.text?.length ?? 0;
    inputElement.innerRef.setSelectionRange(focusIndex, focusIndex);
  }, 0);
}

function onDragOverTitle(item2: any) {
  item2.dragOverTitle = true;
}

function onDragLeaveTitle(item2: any) {
  item2.dragOverTitle = false
}

async function onDropOnTitle(item2: any) {
  item2.dragOverTitle = false
  const dndType = currentEntryStore.dndType
  const dndId = currentEntryStore.dndId
  currentEntryStore.clearDnd()
  // if (['exprResult', 'exprHistory', 'exprEcosystem'].includes(dndType)) {
  if (['exprResult'].includes(dndType)) {
    useExprIdAsAssessment(dndId)
  } else {
    console.log("Not valid for: " + dndType);
  }
}

async function useExprIdAsAssessment(expressionId: string) {
  if (!expressionId) return;
  await commitPendingEdits();
  const entryId = currentEntryStore.currentEntryId;
  const newCcl = await patientapi.addAssessmentCcl(expressionId, entryId);
  dropd.value = null;
  await currentEntryStore.reloadAfterHistoryChange();
  focusOnLastExpr(newCcl.conclusionGroupId);
}


//BODY PARTS
const bodyList = {
  handR: "main droite",
  foreArmR: "avant-bras droit",
  upArmR: "bras droit",
}

function updateBodyPartsForInput() {
  const newBodyPart = currentEntryStore.newBodyPart
  if (newBodyPart === "") return;
  currentEntryStore.clearNewBodyPart()
  if (currentEntryStore.bodyParts.includes(newBodyPart)) {
    addBodyPart(newBodyPart)
  } else {
    removeBodyPart(newBodyPart)
  }
}

function addBodyPart(keyWord) {
  if (keyWord === "" || !(keyWord in bodyList)) return
  let item3 = currentResultLocal.value
  item3.text = item3.text.trimEnd()
  if (currentEntryStore.bodyParts.length > 1 && !item3.text.endsWith(',')) {
    item3.text += ','
  }
  item3.text += ' ' + bodyList[keyWord] + ' '

  //Focus
  focusElement(item3.id.ui)
}

function removeBodyPart(keyWord) {
  if (keyWord === "" || !(keyWord in bodyList)) return;
  const bodyPart = bodyList[keyWord]
  const commaBodyPart = ", " + bodyPart
  let item3 = currentResultLocal.value
  if (item3.text.includes(commaBodyPart)) {
    item3.text = item3.text.replace(commaBodyPart, "");
  } else if (item3.text.includes(bodyPart)) {
    item3.text = item3.text.replace(bodyPart, "");
  }
  item3.text = item3.text.trimStart()
  if (item3.text.startsWith(',')) {item3.text = item3.text.replace(',', '')}
  item3.text = item3.text.trimStart()

  //Focus
  focusElement(item3.id.ui)
}

function syncBodyParts(newText) {
  //newText VS currentResultLocal.value.text
  const updatedBodyParts = Object.keys(bodyList).filter(key =>
      newText.toLowerCase().includes(bodyList[key].toLowerCase())
  )
  currentEntryStore.syncBodyParts(updatedBodyParts)
}

const expandedARR = reactive([])

const currEntryId = computed(() => {
  return currentEntryStore.currentPatientId
})


const sctLanguage = computed(() => {
  return appUserStore?.currentAppUserData?.preferences?.sctLanguage;
})

const inputRefs = ref([]);

// ===== CS LIST LOADING =====
let csAbortController: AbortController | null = null;

function onDateSaved(newIso: string) {
  currentEntryStore.setCurrentEntryDate(newIso);
  rebuildCsList();
}

async function rebuildCsList(): Promise<void> {
  await pendingWork;
  if (!currentEntryStore.hasCurrentEntry) {
    emits('changeShowRightBar', false);
    return;
  }
  csAbortController?.abort();
  csAbortController = new AbortController();
  currentEntryStore.csList = [];
  page.value = 0;
  canLoadMoreCs.value = true;
  csListLoading.value = false;
  init.value = false;
  emits('changeShowRightBar', true);
  return loadMoreCs();
}

async function filterCs() {
  // Flush the current row's unsaved text before throwing the list away.
  await commitPendingEdits();
  return rebuildCsList();
}

function initCsFilter(): GetConsultationsRequest {
  const request : GetConsultationsRequest = {
      currentConsultationsId : currentEntryStore.currentEntryId,
      patientId : currentEntryStore.currentPatientId,
      page : page.value,
      size : size,
  };


  if (uiStore.creatorFilter === "AppUserInstitute") {
    request.instituteId = appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId
  } else if (uiStore.creatorFilter === "AppUserHealthProType") {
    request.healthProType = appUserStore.currentHealthGroupMembership.pwr.healthProType
  } else if (uiStore.creatorFilter === "AppUser") {
    request.myConsultations = true;
  }

  if (uiStore.yearFilter) {
    request.year = uiStore.yearFilter;
  }

  if (uiStore.resultFilter) {
    request.resultType = uiStore.resultFilter;
  }

  if (uiStore.cclDocumentFilter) {
    request.documentType = uiStore.cclDocumentFilter;
  }


  return request;
}

function loadMoreCs(): Promise<void> {
  if (!currentEntryStore.hasCurrentEntry) {
    return Promise.resolve();
  }
  if (csListLoading.value || !canLoadMoreCs.value) {
    return Promise.resolve();
  }
  csListLoading.value = true;
  const signal = csAbortController?.signal;
  return folderPatientApi.getConsultations(initCsFilter(), { signal })
    .then(res => {
      currentEntryStore.csList.push(...res.consultations);
      page.value++;
      canLoadMoreCs.value = !res.last;
    })
    .catch(err => {
      if (err?.name === 'AbortError') { return ; }
    })
    .finally(() => {
      if (!signal?.aborted) {
        csListLoading.value = false;
      }
    });
}

function initObserver() {
  if (!infiniteScrollTrigger.value) return
  observer?.disconnect();
  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadMoreCs()
      }
    },
    {
      root: null,
      rootMargin: "300px",
      threshold: 0
    }
  )

  observer.observe(infiniteScrollTrigger.value)
}

function updateRootGroup(ccl) {
  let rootsGroups = {};
  if (!ccl.resultsArr) return;
  ccl.resultsArr.forEach(expr_ccl => {
    const expr = expr_ccl.expression
    if (!expr) return;
    if (expr.isMatched && !expr.isFamilyHistory && !expr.isNegated ) {
      const siteRootGroup = expr.siteRootGroup
      const siteRootGroupIndex = expr.siteRootGroupIndex
      const aggressorRootGroup = expr.aggressorRootGroup
      const aggressorRootGroupIndex = expr.aggressorRootGroupIndex
      if (expr.siteFindingRoot !== "Specimen") {
        rootsGroups[siteRootGroup] = rootsGroups[siteRootGroup] || {
          "rootGroup": siteRootGroup,
          "rootGroupIndex": siteRootGroupIndex,
          "isMarked" : false,
        }
      }
      rootsGroups[aggressorRootGroup] = rootsGroups[aggressorRootGroup] || {
        "rootGroup": aggressorRootGroup,
        "rootGroupIndex": aggressorRootGroupIndex,
        "isMarked" : false,
      }
      if (expr_ccl.isMarked && expr.siteFindingRoot !== "Specimen") {
        rootsGroups[siteRootGroup].isMarked = true
        rootsGroups[aggressorRootGroup].isMarked = true
      }
    }
  })
   const groupTitle = computeGroupTitle(rootsGroups);
    ccl.groupText = groupTitle || t('patient.conclusionGroup.numberedTitle', { number: ccl.groupOrder })
}

function computeGroupTitle(rootsGroups) {
   let rootGroupArray = Object.values(rootsGroups).filter(rootGroup => !['None', 'Multi'].includes(rootGroup.rootGroup))
        const markedRootGroupArray = rootGroupArray.filter(rootGroup => rootGroup.isMarked)
        if (markedRootGroupArray.length > 0) {
          rootGroupArray = markedRootGroupArray
        } else {
          rootGroupArray = rootGroupArray.filter(rootGroup => !['Pain', 'Physical', 'Exogenous', 'Procedure'].includes(rootGroup.rootGroup))
          if (rootGroupArray.length > 1) {
            rootGroupArray = rootGroupArray.filter(rootGroup => !['Substance'].includes(rootGroup.rootGroup))
          }
        }

        rootGroupArray.sort((a, b) => a.rootGroupIndex - b.rootGroupIndex)
        return rootGroupArray
            .map(rootGroup => rootGroup.rootGroup)
            .join(", ")
}

function isCclDeletable(ccl) {
  const isCurrentEntry = ccl.relationshipId === currentEntryStore.currentEntryId
  return isCurrentEntry
      && ccl.conclusionText === ""
      && ccl.resultsArr.length <= 1
      && ccl.templateDocArr.length === 0
}

function hproName(hpro) {
  if (!hpro) return "";
  return PersonService.formatHonorificAndName(hpro.title, hpro.lastName, hpro.firstName);  
}

async function item3ProxyFCT(expr) {
  if (!expr?.expression?.originalText && expr?.expression?.expressionType !== "ResultDocument") return;
  //Clear & Close Expr modal
  currentEntryStore.clearCurrExpr_Ccl();

  if (expr.expression.expressionType !== "ResultDocument" && expr.expression.sctProxyKey) {
    const expressions = await folderPatientApi.getExpressions({
      patientId : currentEntryStore.currentPatientId,
      sctProxyKey: expr.expression.sctProxyKey
    })

    const refSheetSuggestions = await appuserapi.getRefSheetsForExpr(expr.expressionId)
    currentEntryStore.setCurrSuggestionsForDashboard(refSheetSuggestions)

    if (!expressions.some(exp => exp.expressionId === expr.expression.expressionId)) {
      currentEntryStore.allExpressions = [...expressions, expr.expression];
    } else {
      currentEntryStore.allExpressions = expressions;
    }
  }

  if (expr.expression.expressionType !== "ResultDocument" && expr.expression.conceptGroupId) {
    const expressions = await folderPatientApi.getExpressionsByConceptGroupAndPatient({
      patientId : currentEntryStore.currentPatientId,
      conceptGroupId: expr.expression.conceptGroupId
    })

    const refSheetSuggestions = await appuserapi.getRefSheetsForExpr(expr.expressionId)
    currentEntryStore.setCurrSuggestionsForDashboard(refSheetSuggestions)

    currentEntryStore.allExpressions = expressions;

  }

  //Select dashboard
  uiStore.setDashBoardItem(expr)
}

function csExpand(item) {
  gen.arrSwitch(item.id.ui, expandedARR)
}


//Upload via Paperclip
async function handleFiles(files, item1: any, item2: any, item3: any) {
  if (!isItem1Editable(item1)) return;
  await commitPendingEdits();
  if (typeof item3.expressionCclId === 'string' && item3.expressionCclId.startsWith('local-')) return;
  currentEntryStore.setCurrentCs(item1);
  currentEntryStore.setCurrentCcl(item2);
  currentEntryStore.setCurrentResult(item3);
  //Save
  const entryId = currentEntryStore.currentEntryId;
  let expression_CclId = item3.expressionCclId
  dropd.value = "";
  //Create a new Expr_ccl if current is not available
  let newExpr_ccl = null;
  if (item3.isResultDocument || item3.text !== '') {
    newExpr_ccl = await createTempRow("")
    addRowBelow(newExpr_ccl)
    expression_CclId = newExpr_ccl.expressionCclId;
  }
  //Add files
  await patientapi.addFilesAfterCurrent(expression_CclId, entryId, files)
  focusElement(newExpr_ccl?.id.ui || item3.id.ui)
  currentEntryStore.reloadCurrentEntry();
}

//Upload via drag and drop
function onDropOnInputArea(e, item1, item2, item3) {
  e.preventDefault();
  e.stopPropagation();
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    handleFiles(files, item1, item2, item3);
  }
}

function onDragOverInputArea(item3: any) {
  item3.dragOverInputArea = true;
}

function onDragLeaveInputArea(item3: any) {
  item3.dragOverInputArea = false;
}


//Drag 'N Drop title
function onDragStart(item3) {
  //Clear & Close modal
  if (currentCclLocal.value) {
    currentEntryStore.clearCurrExpr_Ccl()
    currentEntryStore.setMiddleTab('resultSuggestions')
  }
  //Store
  currentEntryStore.setDndType("exprResult")
  currentEntryStore.setDndId(item3.expressionId)
  currentEntryStore.setDndObject(item3)
}

function onDragEnd() {
  currentEntryStore.clearDnd()
}

//Field Copy-Paste
function copyResultToActiveField(item3: any) {
  if (!currentEntryStore.activeFieldElement) return;
  const resultText = item3.text.trim()
  if (resultText === '') return;
  const existingText = currentEntryStore.activeFieldElement.value;
  const prefix = existingText.trim() ? '\n' : '';
  currentEntryStore.insertTextAtCursor(prefix + resultText);
}

function copyGroupToActiveField(item1: any, item2: any) {
  if (!currentEntryStore.activeFieldElement) return;
  const entryDate = formatUTCDateTimeToDate(item1.entryStart)
  const groupTitle = item2.assessmentExpr?.buttonText || ''
  const filteredResults = item2.resultsArr
    .map(obj => obj.text.trim())
    .filter(text => text !== '');
  const resultText = filteredResults.length > 0
    ? filteredResults.join('\n') + '\n'
    : '';
  const existingText = currentEntryStore.activeFieldElement.value;
  const prefix = existingText.trim() ? '\n' : '';
  const ret = groupTitle
    ? `${prefix}${groupTitle.toUpperCase()} - ${entryDate}\n${resultText}`
    : `${prefix}${entryDate}\n${resultText}`;
  currentEntryStore.insertTextAtCursor(ret);
}

//Hover Buttons
function highlighterFct(item3: any) {
  const expression_CclId = item3.expressionCclId
  const newBoolean = !item3.isMarked
  //Frontend
  item3.isMarked = newBoolean
  dropd.value = "";
  //Backend
  patientapi.updateExpressionIsMarked(expression_CclId, newBoolean)
}

async function insertCclGroupFct() {
  await commitPendingEdits();
  const entryId = currentEntryStore.currentEntryId
  await patientapi.insertNewBlankConclusion(entryId)
  addedNewGroup.value = true
  await currentEntryStore.reloadCurrentEntry();
  focusOnLastExpr();
}

function openExpressionMenu(item: any) {
  dropd.value = 'ExprMenu' + item.id.ui;
}

const createNewEntry = () => {
  if (!hasDelegate.value) {
    delegateId.value = null; //No delegation
    confirmCreateNewEntry();
  }
}

const createNewEntryWithModal = () => {
  if (hasDelegate.value){
    openSelectHealthProDelegate.value = true;
  }
}

const hasDelegate = computed(() => {
  const delegates = appUserStore.healthProDelegate ?? [];
  return !isCurrentUserHealthPro.value || delegates.length > 1;
})

const closeSelectHealthProDelegateModal = (selectedPersonLight: PersonLightResponse) => {
  if (selectedPersonLight) {
    const currUserId = currentUserPwr.value?.personWithRoleId;
    delegateId.value = selectedPersonLight.id !== currUserId
      ? selectedPersonLight.id
      : null;   //No delegation
    confirmCreateNewEntry();
  } else {
    openSelectHealthProDelegate.value = false;
  }
}

async function confirmCreateNewEntry() {
  await commitPendingEdits();
  const newEntry = await currentEntryStore.createNewEntry(
    currentEntryStore.currentPatient.personWithRoleId,
    appUserStore.getCurrentInstituteWithRole().instituteWithRoleId,
    delegateId.value
  );
  openSelectHealthProDelegate.value = false;
  currentEntryStore.csList.unshift(newEntry);
  emits('changeShowRightBar', true);
  currentEntryStore.setReloadSummaryData(true);
  nextTick(() => {
    selectLatestExpression();
    focusOnLastExpr(currentCclLocal.value?.conclusionGroupId);
  });
}

const years = ref([]);

async function getOldestPerYear() {

  if(years.value.length == 0) {
    const res = await folderPatientApi.getYearsInPatientFolder({
      patientId: currentEntryStore.currentPatient.personWithRoleId
    });
    years.value = res;
  }

}

function scrollToTop() {
  //Get entryId
  const entryId = currentEntryStore.currentEntryId || ""
  if (!entryId) {return;}
  //Get entryElement
  const elementId = 'entry_' + entryId
  const targetElement = document.getElementById(elementId)
  if (!targetElement) {return;}
  //Scroll
  targetElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  dropd.value = "";
}

const dropd = ref()

function setSelection(cs, ccl, result) {
  currentEntryStore.setCurrentCs(cs);
  currentEntryStore.setCurrentCcl(ccl);
  currentEntryStore.setCurrentResult(result);
  currentEntryStore.updateCclSuggestionsForCclText(ccl.conclusionText);
  if (ccl.groupOrder !== -1) {
    currentEntryStore.updateCclSuggestionsForResults(ccl.conclusionGroupId.toString());
  }
}

function getCurrentCs() {
  if (!currentEntryStore.csList?.length) return null;
  const currentEntryId = currentEntryStore.currentEntryId;
  return currentEntryStore.csList.find(cs => cs.relationshipId === currentEntryId);
}

function selectLatestExpression() {
  if (!currentEntryStore.csList?.length) return false;
  const targetCs = getCurrentCs() || currentEntryStore.csList[0];
  const firstCcl = targetCs?.conclusionGroups?.find(ccl => ccl.resultsArr?.length > 0);
  const firstResult = firstCcl?.resultsArr?.[0];
  if (targetCs && firstCcl && firstResult) {
    setSelection(targetCs, firstCcl, firstResult);
    return true;
  }
  return false;
}

function initializeFirstCs() {
  if (init.value) return;
  if (selectLatestExpression()) {
    init.value = true;
  }
}

function hasCclContent(item2) {
  return item2.conclusionText !== ''
    || item2.sapExprArr?.length
    || item2.templateDocArr?.length
    || item2.bioPrescrArr?.length
}

function isCclVisible(item1, item2) {
  return item2.groupOrder !== -1
    && !item2.isCreatedByService
    && (isItem1Editable(item1) || hasCclContent(item2))
}

function isItem1Editable(item) {
  return item.relationshipId === currentEntryStore.currentEntryId && currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
}

function isConclusionGroupEditable(item) {
  return !item.isCreatedByService;
}

function onMouseHoverStart(item) {
  item.hover = true;
}

function onMouseHoverEnd(item) {
  item.hover = false;
}

const areFiltersActive = computed(() => {
  const resultFilter = uiStore.resultFilter
  const creatorFilter = uiStore.creatorFilter
  const cclDocumentFilter = uiStore.cclDocumentFilter
  return resultFilter || creatorFilter || cclDocumentFilter || uiStore.yearFilter;
})

async function clearFilters() {
  uiStore.setResultFilter('');
  uiStore.setCreatorFilter('');
  uiStore.setCclDocumentFilter('');
  uiStore.setYearFilter('');
}

function setYearFilter(year: string) {
  uiStore.setYearFilter(year);
  dropd.value = "";
}

function isOphthalmoGroup(titleGroup: string): boolean {
  //Dirty way to do the check, but there isn’t any other way available.
  const groups = ['Réfraction','Tonomètre', 'Lampe à fente','Champ visuel',"Fond d'oeil",'Topography','Echographie','Biométrie','OCT','Frontofocomètre']
  return groups.includes(titleGroup);
}

const openConfirmArchiveRestoreModal = async (entryId: string, isArchived: boolean) => {
  if (entryId) {
    if (isArchived) {
      await folderPatientApi.canArchiveEntry({ patientId: currentEntryStore.currentPatient.personWithRoleId, entryId: entryId}).then((checkArchiveResponse: CheckArchiveResponse) => {
        if (!checkArchiveResponse.allowed) {
          archiveNotAllowed.value = true;
          confirmMessage.value = t(`error.${checkArchiveResponse.warningCode}`);
        } else {
          confirmMessage.value = t('patient.entry.archive.message');
        }

        isArchiveRestoreModalOpen.value = true;
        entryIdToArchiveRestore.value = entryId;
        confirmHeader.value = t('patient.entry.archive.header');
        archiveRestoreValidationMessage.value = t('patient.entry.archive.confirm');
      }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(error?.status ? `error.${error.status}` : 'error.DEFAULT')
        });

        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw t('error.DEFAULT');
      });
    } else {
      isArchiveRestoreModalOpen.value = true;
      entryIdToArchiveRestore.value = entryId;
      confirmHeader.value =  t('patient.entry.restore.header');
      archiveRestoreValidationMessage.value = t('patient.entry.restore.confirm');
      confirmMessage.value = t('patient.entry.restore.message');
    }
  }
}

const initArchiveRestoreDate = () => {
  isArchiveRestoreModalOpen.value = false;
  entryIdToArchiveRestore.value = undefined;
  confirmMessage.value = undefined;
  confirmHeader.value = undefined;
  archiveNotAllowed.value = false;
}

const closeConfirmArchiveRestoreEntryModal = async (isConfirmed : boolean) => {
  if(isConfirmed &&  entryIdToArchiveRestore.value){
    await folderPatientApi.archiveOrRestoreEntry({ patientId: currentEntryStore.currentPatient.personWithRoleId, entryId: entryIdToArchiveRestore.value}).then(() => {
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  archiveRestoreValidationMessage.value
      });
      initArchiveRestoreDate();
      rebuildCsList();
      currentEntryStore.clearBodyParts();
      currentEntryStore.setMiddleTab('resultSuggestions');
      currentEntryStore.setReloadSummaryData(true);
      currentEntryStore.setReloadTreatmentData(true);
      currentEntryStore.reloadAfterHistoryChange();
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: t(error?.status ? `error.${error.status}` : 'error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw t('error.DEFAULT');
    });
  } else {
    initArchiveRestoreDate();
  }
}

watch(
    () => currentEntryStore.newBodyPart,
    () => {updateBodyPartsForInput()}
)

watch(
    () => currentEntryStore.newEntryText,
    () => {addSuggestionRow()}
)

watch(
  () => [
    uiStore.resultFilter,
    uiStore.cclDocumentFilter,
    uiStore.fetchFilter,
    uiStore.creatorFilter,
    uiStore.yearFilter,
    currentEntryStore.csListRefreshKey,
  ],
  () => {
    filterCs();
  }
)

let lastBuiltPatientId: string | null = null;

watch(
  () => currentEntryStore.isLoading,
  async (isLoading, wasLoading) => {
    if (wasLoading && !isLoading) {
      await pendingWork;  // Let queued saves/deletes settle
      if (lastBuiltPatientId !== currentEntryStore.currentPatientId) {
        // Patient changed → full rebuild.
        lastBuiltPatientId = currentEntryStore.currentPatientId;
        rebuildCsList();
      } else {
        // Same patient (reload triggered by a mutation) → don't clobber the
        // optimistic list, just restore focus on the current row.
        nextTick(() => {
          nextTick(() => {  // Double nextTick to wait for reactive update
            if (currentEntryStore.middleTab !== 'resultSuggestions') { return; } //Don't focus if the tab has changed in the meanwhile
            const result = currentResultLocal.value
            if (result?.id?.ui) {
              focusElement(result.id.ui)
            }
          })
        })
      }
    }
  }
)

watch(
  () => currentEntryStore.csList.length,
  (len) => {
    if (!len) return;
    initializeFirstCs();
    if (addedNewGroup.value) focusOnLastExpr();
  }
)

watch(
  () => currentEntryStore.conclusionIdToFocusOnExpr,
  (conclusionId) => {
    if (!conclusionId) return;
    setTimeout(() => {
      focusOnLastExpr();
      currentEntryStore.setConclusionIdToFocusOnExpr(null);
    }, 0);
  }
)

watch(infiniteScrollTrigger, async (el) => {
  if (el) {
    await nextTick()
    initObserver()
  }
})

onMounted(() => {
  currentEntryStore.setMiddleTab('resultSuggestions');
  window.addEventListener('beforeunload', onBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', onBeforeUnload);
  observer?.disconnect();
  observer = null;
});

watch(
  () => route.params.patientId,
  async () => {
        await commitPendingEdits();
        csAbortController?.abort();
        csAbortController = new AbortController();
        currentEntryStore.csList = [];
        page.value = 0;
        canLoadMoreCs.value = true;
        csListLoading.value = false;
        init.value = false;
        lastBuiltPatientId = null;    // forces a rebuild once the new patient finishes loading
  }
);

return (_ctx: any,_cache: any) => {
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _directive_one_click = _resolveDirective("one-click")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(currentEntryStore).csList && !_unref(currentEntryStore).currentPatient)
      ? (_openBlock(), _createBlock(loadingScreen, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_unref(currentEntryStore).hasCurrentEntry)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_dropdownBox, {
                        modelValue: dropd.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                        openOn: 'year'
                      }, {
                        dropd: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_dbGroup, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_list_group, {
                                    styles: "pad-s",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (scrollToTop()), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(TextItem, {
                                        txt: _unref(t)('patient.actionButton.scrollToTop')
                                      }, null, 8, ["txt"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "w-3",
                                    key: index
                                  }, [
                                    _createVNode(_component_list_group, {
                                      styles: "pad-s",
                                      onClick: _withModifiers(($event: any) => (setYearFilter(item)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(TextItem, { txt: item }, null, 8, ["txt"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(EsButtonIcon, {
                            styles: "square-16",
                            buttonStyles: "flex-square-24",
                            icon: "calendar-arrow-to",
                            folder: "menuIcons",
                            onClick: getOldestPerYear
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (areFiltersActive.value)
                        ? (_openBlock(), _createBlock(_component_buttonGroup, {
                            key: 0,
                            styles: "pad-m",
                            class: "align-center header-column-right",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilters()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "x",
                                styles: "size-m main-h",
                                class: "img-primary"
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_dropdownBox, { key: 1 }, {
                            dropd: _withCtx(() => [
                              _createVNode(lBarFilters)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_buttonGroup, {
                                styles: "pad-m",
                                class: "align-center header-column-right"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_svg_item, {
                                    icon: "filter",
                                    styles: "size-m main-h"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(lBarHeaderFilters)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (showCreateNewEntryButton.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!hasDelegate.value)
                      ? _withDirectives((_openBlock(), _createBlock(_component_buttonGroup, {
                          key: 0,
                          styles: "pad-m",
                          class: "align-center header-column-right mleft-15 mtop-01"
                        }, {
                          default: _withCtx(() => [
                            _cache[18] || (_cache[18] = _createElementVNode("img", {
                              src: _imports_0,
                              class: "img-primary"
                            }, null, -1)),
                            _createVNode(TextItem, {
                              txt: _unref(t)('patient.actionButton.newEntry'),
                              class: "mleft-05 txt-primary font-size-14"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })), [
                          [_directive_one_click, createNewEntry]
                        ])
                      : (_openBlock(), _createBlock(_component_buttonGroup, {
                          key: 1,
                          styles: "pad-m",
                          class: "align-center header-column-right mleft-15 mtop-01",
                          onClick: createNewEntryWithModal
                        }, {
                          default: _withCtx(() => [
                            _cache[19] || (_cache[19] = _createElementVNode("img", {
                              src: _imports_0,
                              class: "img-primary"
                            }, null, -1)),
                            _createVNode(TextItem, {
                              txt: _unref(t)('patient.actionButton.newEntry'),
                              class: "mleft-05 txt-primary font-size-14"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentEntryStore).csList, (item1) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item1.relationshipId,
                  class: "consolidations-list",
                  id: 'entry_' + item1.relationshipId
                }, [
                  (isItem1Editable(item1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_dropdownBox, null, _createSlots({
                          default: _withCtx(() => [
                            _createVNode(_component_buttonGroup, {
                              class: "events-1 pright-00",
                              styles: "pad-s"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(TextItem, {
                                    txt: _unref(formatUTCDateTimeToDate)(item1.entryStart),
                                    class: "date-day txt-grey-64"
                                  }, null, 8, ["txt"]),
                                  _createVNode(TextItem, {
                                    txt: _unref(formatUTCDateTimeToTime)(item1.entryStart),
                                    class: "date-hour txt-grey-64"
                                  }, null, 8, ["txt"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, [
                          (isItem1Editable(item1))
                            ? {
                                name: "dropd",
                                fn: _withCtx(() => [
                                  _createVNode(lBarChangeCsDate, { "on-saved": onDateSaved })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1024)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(TextItem, {
                          txt: _unref(formatUTCDateTimeToDate)(item1.entryStart),
                          class: _normalizeClass(["date-day", item1.archivedByUser ? 'txt-grey-40' : 'txt-grey-64'])
                        }, null, 8, ["txt", "class"]),
                        (!item1.archivedByUser)
                          ? (_openBlock(), _createBlock(TextItem, {
                              key: 0,
                              txt: _unref(formatUTCDateTimeToTime)(item1.entryStart),
                              class: "date-hour txt-grey-64"
                            }, null, 8, ["txt"]))
                          : _createCommentVNode("", true)
                      ])),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "line" }, null, -1)),
                      _createElementVNode("div", _hoisted_13, [
                        (item1.archivedByUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('patient.entry.archived')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_dropdownBox, {
                                modelValue: dropd.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
                                openOn: 'lBarCsHeader' + item1.relationshipId
                              }, {
                                dropd: _withCtx(() => [
                                  _createVNode(EsConsultationDetails, {
                                    initial: _unref(StringService).getInitial(item1.healthPro.lastName, item1.healthPro.firstName),
                                    doctorName: hproName(item1.healthPro),
                                    secondaryHealthProName: hproName(item1.secondaryHealthPro),
                                    instituteName: item1.instituteWithRole.instituteShortName,
                                    displayImportBy: item1.isCreatedByService
                                  }, null, 8, ["initial", "doctorName", "secondaryHealthProName", "instituteName", "displayImportBy"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_buttonGroup, {
                                    styles: "pad-0",
                                    class: "psides-04 gap-01"
                                  }, {
                                    default: _withCtx(() => [
                                      (item1.isCreatedByService || item1.secondaryHealthPro)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(StringService).getInitial(item1.healthPro.lastName, item1.healthPro.firstName)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "openOn"]),
                              _createElementVNode("div", _hoisted_19, [
                                (isItem1Editable(item1))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(DateService).getWeekDayLongFormat(item1.entryStart, localeForJs.value)), 1),
                                      _cache[20] || (_cache[20] = _createTextVNode("   ")),
                                      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(format)(new Date(item1.entryStart), _unref(DateFormat).FRONT_DAY, { locale: local.value })), 1),
                                      _createTextVNode("  " + _toDisplayString(_unref(format)(new Date(item1.entryStart), _unref(DateFormat).FRONT_MONTH_YEAR_LETTER, { locale: local.value })), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(format)(new Date(item1.entryStart), _unref(DateFormat).FRONT_FULL, { locale: local.value })), 1))
                              ])
                            ])),
                        _createVNode(EsPatientActionMenu, {
                          itemUuid: item1.relationshipId,
                          "label-action": item1.archivedByUser ? _unref(t)('patient.entry.restore.header') : _unref(t)('patient.entry.archive.header'),
                          "icon-action": item1.archivedByUser ? 'arrow-clockwise' : 'trash',
                          "path-icon-action": item1.archivedByUser ? 'shareIcons' : 'settings',
                          "text-to-display": item1.archivedByUser ? _unref(t)('patient.entry.archivedBy', {author: _unref(PersonService).formatHonorificAndName(undefined, item1.archivedByUser.lastName, item1.archivedByUser.firstName), deletedDate: item1.archivedDate}) : undefined,
                          "icon-menu-class": item1.archivedByUser ? 'filter-grey' : undefined,
                          onMenuAction: ($event: any) => (openConfirmArchiveRestoreModal($event, !item1.archivedByUser))
                        }, null, 8, ["itemUuid", "label-action", "icon-action", "path-icon-action", "text-to-display", "icon-menu-class", "onMenuAction"])
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "line" }, null, -1))
                    ]),
                    (!item1.archivedByUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (item1.isCreatedByService && item1.conclusionGroups[1]?.resultsArr?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  (item1.conclusionGroups[1].resultsArr[0].expression.expressionType === 'ResultDocument')
                                    ? (_openBlock(), _createBlock(EsButtonIcon, {
                                        key: 0,
                                        icon: "doc",
                                        folder: "shareIcons",
                                        styles: "img-black square-16",
                                        buttonStyles: "flex-square-24",
                                        onClick: ($event: any) => (item3ProxyFCT(item1.conclusionGroups[1].resultsArr[0]))
                                      }, null, 8, ["onClick"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_26)),
                                  _createVNode(TextItem, {
                                    txt: item1.conclusionGroups[1].resultsArr[0].expression.originalText,
                                    class: "h6"
                                  }, null, 8, ["txt"]),
                                  (!isItem1Editable(item1) && item1.conclusionGroups[1] && item1.conclusionGroups[1].resultsArr.length > 3)
                                    ? (_openBlock(), _createBlock(_component_button_group, {
                                        key: 2,
                                        onClick: ($event: any) => (csExpand(item1.conclusionGroups[1])),
                                        styles: "pad-s",
                                        class: "mleft-06"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_item, {
                                            icon: expandedARR.includes(item1.conclusionGroups[1].id.ui) ? 'chevronsDown': 'chevronsUp',
                                            styles: "size-l",
                                            class: "filter-grey"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mleft-04" }, null, -1)),
                                  (item1.conclusionGroups[1] && item1.conclusionGroups[1].resultsArr[0].expression.isCorrected)
                                    ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                        key: 3,
                                        modelValue: dropd.value,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
                                        openOn: 'lBarCsGroupImportedTitleCorrected' + item1.conclusionGroups[1].resultsArr[0].id.ui
                                      }, {
                                        dropd: _withCtx(() => [
                                          _createVNode(editExpressionHistory, {
                                            expression: item1.conclusionGroups[1].resultsArr[0].expression,
                                            entry: item1
                                          }, null, 8, ["expression", "entry"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_buttonGroup, { class: "events-1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(TextItem, {
                                                txt: _unref(t)('patient.expression.isCorrected'),
                                                styles: "font-s main-l"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "openOn"]))
                                    : _createCommentVNode("", true),
                                  (_unref(currentEntryStore).isEditable)
                                    ? (_openBlock(), _createBlock(rBarMoreMenu, {
                                        key: 4,
                                        expr: item1.conclusionGroups[1].resultsArr[0].expression,
                                        class: "events-1 mleft-auto",
                                        isRightBar: false
                                      }, null, 8, ["expr"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            (item1.conclusionGroups[1] && expandedARR.includes(item1.conclusionGroups[1].id.ui))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createVNode(TextItem, {
                                    txt: item1.conclusionGroups[1].resultsArr[0].expression.metaDataText,
                                    class: "font-size-12 mleft-15 linebreak",
                                    styles: "main-m"
                                  }, null, 8, ["txt"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.conclusionGroups, (item2, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: item2.conclusionGroupId
                              }, [
                                (item2.row > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item2.row > 1)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            style: _normalizeStyle({'grid-row' : item2.row}),
                                            class: "col mleft-04 es-conclusion"
                                          }, [
                                            (!item1.isCreatedByService)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                  _createElementVNode("div", _hoisted_31, [
                                                    (_unref(currentEntryStore).activeFieldElement)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createElementVNode("div", {
                                                            class: "flex-square-24",
                                                            onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                                                            onClick: ($event: any) => (copyGroupToActiveField(item1, item2))
                                                          }, [
                                                            _createVNode(_component_svg_item, {
                                                              icon: "documents",
                                                              styles: "size-m main-h"
                                                            })
                                                          ], 40, _hoisted_32),
                                                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mleft-06" }, null, -1))
                                                        ], 64))
                                                      : _createCommentVNode("", true),
                                                    (item2.isAssessment && !isOphthalmoGroup(item2.assessmentExpr.buttonText))
                                                      ? (_openBlock(), _createBlock(_component_listGroup2, {
                                                          key: 1,
                                                          id: 'conclusionTitle_' + item2.conclusionGroupId,
                                                          class: "row w-auto",
                                                          onClick: ($event: any) => (item3ProxyFCT(item2.assessmentExpr)),
                                                          draggable: "true",
                                                          onDragstart: ($event: any) => (onDragStart(item2.assessmentExpr)),
                                                          onDragend: onDragEnd
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_33, [
                                                              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mleft-01" }, null, -1)),
                                                              (!_unref(currentEntryStore).activeFieldElement)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createElementVNode("div", null, [
                                                                      _createVNode(_component_svg_item, {
                                                                        icon: "text",
                                                                        styles: "main-m size-m"
                                                                      })
                                                                    ]),
                                                                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mleft-03" }, null, -1))
                                                                  ], 64))
                                                                : _createCommentVNode("", true),
                                                              _createVNode(TextItem, {
                                                                txt: item2.assessmentExpr.buttonText,
                                                                styles: "main-h font-mBold"
                                                              }, null, 8, ["txt"])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["id", "onClick", "onDragstart"]))
                                                      : (_openBlock(), _createElementBlock("div", {
                                                          key: 2,
                                                          id: 'conclusionTitle_' + item2.conclusionGroupId,
                                                          class: _normalizeClass([(item2.dragOverTitle && _unref(currentEntryStore).dndType) ? 'bigshadow' : '']),
                                                          onDragover: _withModifiers(($event: any) => (onDragOverTitle(item2)), ["prevent"]),
                                                          onDragleave: ($event: any) => (onDragLeaveTitle(item2)),
                                                          onDrop: _withModifiers(($event: any) => (onDropOnTitle(item2)), ["prevent"])
                                                        }, [
                                                          _createVNode(TextItem, {
                                                            txt: item2.groupText,
                                                            styles: "font-mBold"
                                                          }, null, 8, ["txt"])
                                                        ], 42, _hoisted_34)),
                                                    (item2.isAssessment && item2.assessmentExpr?.expression?.isCorrected)
                                                      ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                                          key: 3,
                                                          modelValue: dropd.value,
                                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd).value = $event)),
                                                          openOn: 'lBarCsGroupTitleCorrected' + item2.id.ui
                                                        }, {
                                                          dropd: _withCtx(() => [
                                                            _createVNode(editExpressionHistory, {
                                                              expression: item2.assessmentExpr,
                                                              entry: item1
                                                            }, null, 8, ["expression", "entry"])
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_buttonGroup, { class: "events-1" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(TextItem, {
                                                                  txt: _unref(t)('patient.expression.isCorrected'),
                                                                  styles: "font-s main-l"
                                                                }, null, 8, ["txt"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["modelValue", "openOn"]))
                                                      : _createCommentVNode("", true),
                                                    (!isItem1Editable(item1) && item2.resultsArr.length > 2)
                                                      ? (_openBlock(), _createBlock(_component_button_group, {
                                                          key: 4,
                                                          onClick: ($event: any) => (csExpand(item2)),
                                                          styles: "pad-s",
                                                          class: "mleft-06"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_svg_item, {
                                                              icon: expandedARR.includes(item2.id.ui) ? 'chevronsDown': 'chevronsUp',
                                                              styles: "size-l",
                                                              class: "filter-grey"
                                                            }, null, 8, ["icon"])
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (item2.isAssessment)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                          (_unref(currentEntryStore).isEditable)
                                                            ? (_openBlock(), _createBlock(rBarMoreMenu, {
                                                                key: 0,
                                                                expr: item2.assessmentExpr.expression,
                                                                class: "events-1 mleft-auto",
                                                                isRightBar: false
                                                              }, null, 8, ["expr"]))
                                                            : _createCommentVNode("", true)
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["item-lclist-2 w-full", (item2.id.ui === currentCclLocal.value?.id.ui && _unref(currentEntryStore).middleTab === 'resultSuggestions' && isItem1Editable(item1)) ? 'item-lclist-2-active' : ''])
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.resultsArr, (item3, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: item3.id.ui
                                                }, [
                                                  (!item1.isCreatedByService || item3.expressionOrder > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                        (item3.isMarked || isItem1Editable(item1) || expandedARR.includes(item2.id.ui) || item3.isResultDocument || item3.expressionOrder <= 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                              _createElementVNode("div", _hoisted_37, [
                                                                _createElementVNode("div", _hoisted_38, [
                                                                  (_unref(currentEntryStore).activeFieldElement)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        class: "flex-square-20 mtop-04",
                                                                        onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                                                                        onClick: ($event: any) => (copyResultToActiveField(item3))
                                                                      }, [
                                                                        _createVNode(_component_svg_item, {
                                                                          icon: "documents",
                                                                          styles: "size-m main-h"
                                                                        })
                                                                      ], 40, _hoisted_39))
                                                                    : (_openBlock(), _createElementBlock("div", {
                                                                        key: 1,
                                                                        class: _normalizeClass(["flex-square-20", index === 0
                                                                    ? index === item2.resultsArr.length - 1
                                                                      ? isItem1Editable(item1)
                                                                        ? 'mtop-12px mbottom-8px'
                                                                        : 'mtop-8px mbottom-8px'
                                                                      : 'mtop-8px'
                                                                    : index === item2.resultsArr.length - 1
                                                                    ? 'mbottom-8px'
                                                                    : '']),
                                                                        onClick: ($event: any) => (item3ProxyFCT(item3))
                                                                      }, [
                                                                        (!item3.isResultDocument && isConclusionGroupEditable(item2))
                                                                          ? (_openBlock(), _createElementBlock("img", {
                                                                              key: 0,
                                                                              center: true,
                                                                              uiId: item3.id.ui,
                                                                              src: _imports_2,
                                                                              class: _normalizeClass(["square-14 mtop-02", item3.buttonMatched ? 'matched-color' : 'filter-grey']),
                                                                              onDragstart: ($event: any) => (onDragStart(item3.expression))
                                                                            }, null, 42, _hoisted_41))
                                                                          : _createCommentVNode("", true),
                                                                        (item3.isResultDocument)
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                                                                          : _createCommentVNode("", true)
                                                                      ], 10, _hoisted_40)),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(['group-line', index === 0 ? index === item2.resultsArr.length -1 ? 'one-group-line ptop-8px pbottom-8px' :  'first-group-line ptop-8px' : index === item2.resultsArr.length -1 ? 'last-group-line pbottom-8px' : '', isItem1Editable(item1) ? '' : 'noHover'])
                                                                  }, [
                                                                    _createElementVNode("div", _hoisted_43, [
                                                                      (isItem1Editable(item1) && isConclusionGroupEditable(item2))
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                            _createVNode(_component_inputAreaAuto2, {
                                                                              modelValue: item3.text,
                                                                              "onUpdate:modelValue": ($event: any) => ((item3.text) = $event),
                                                                              id: item3.id.ui,
                                                                              ref_for: true,
                                                                              ref: el => { inputRefs.value[item3.id.ui] = el },
                                                                              styles: ' ' + (item3.isMarked ? 'main-alert' : 'main-h'),
                                                                              class: _normalizeClass([(item3.dragOverInputArea && !_unref(currentEntryStore).dndType) ? 'bigshadow w-full' : 'w-full']),
                                                                              mic: true,
                                                                              showMenu: true,
                                                                              hover: item3.hover,
                                                                              lastRow: (item2.resultsArr.length -1 == index),
                                                                              placeholder: (item2.resultsArr.length -1 == index) ? _unref(t)('patient.expression.addSigns') : '',
                                                                              onClickMenu: ($event: any) => (openExpressionMenu(item3)),
                                                                              onFocus: ($event: any) => (setCurrentResultInput(item1, item2, item3)),
                                                                              onInput: ($event: any) => (textInputFct(item3)),
                                                                              onBlur: ($event: any) => (updateExpr(item3)),
                                                                              onKeydown: [
                                                                                _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (addBlankRow()), ["stop","prevent"]), ["enter"])),
                                                                                _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (backSpaceFct($event)), ["stop"]), ["backspace"])),
                                                                                _withKeys(_withModifiers(($event: any) => (handleTabToNext(item2)), ["prevent"]), ["tab"])
                                                                              ],
                                                                              onMouseover: ($event: any) => (onMouseHoverStart(item3)),
                                                                              onMouseleave: ($event: any) => (onMouseHoverEnd(item3)),
                                                                              onDrop: _withModifiers(($event: any) => (onDropOnInputArea($event, item1, item2, item3)), ["prevent"]),
                                                                              onDragover: _withModifiers(($event: any) => (onDragOverInputArea(item3)), ["prevent"]),
                                                                              onDragleave: ($event: any) => (onDragLeaveInputArea(item3))
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "styles", "class", "hover", "lastRow", "placeholder", "onClickMenu", "onFocus", "onInput", "onBlur", "onKeydown", "onMouseover", "onMouseleave", "onDrop", "onDragover", "onDragleave"]),
                                                                            _createVNode(_component_dropdownBox, {
                                                                              modelValue: dropd.value,
                                                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event)),
                                                                              openOn: 'ExprMenu' + item3.id.ui
                                                                            }, {
                                                                              dropd: _withCtx(() => [
                                                                                _createElementVNode("div", _hoisted_44, [
                                                                                  _createVNode(_component_dbGroup, null, {
                                                                                    default: _withCtx(() => [
                                                                                      (item3.text !== '')
                                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                            _createVNode(_component_list_group, {
                                                                                              class: "w-full",
                                                                                              styles: "pad-m",
                                                                                              onClick: ($event: any) => (useExprIdAsAssessment(item3.expressionId))
                                                                                            }, {
                                                                                              default: _withCtx(() => [
                                                                                                _createElementVNode("div", null, [
                                                                                                  _createVNode(_component_svg_item, {
                                                                                                    icon: "text",
                                                                                                    styles: "size-m main-l",
                                                                                                    style: {"margin-top":"-0.1rem"}
                                                                                                  })
                                                                                                ]),
                                                                                                _createVNode(TextItem, {
                                                                                                  txt: item2.assessmentExpressionId ? 'Créer groupe + titre' :'Créer titre',
                                                                                                  class: "mleft-04",
                                                                                                  styles: "main-m"
                                                                                                }, null, 8, ["txt"])
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1032, ["onClick"]),
                                                                                            _createVNode(_component_list_group, {
                                                                                              class: "w-full",
                                                                                              styles: "pad-m",
                                                                                              onClick: ($event: any) => (highlighterFct(item3))
                                                                                            }, {
                                                                                              default: _withCtx(() => [
                                                                                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex-square-20 filter-grey" }, [
                                                                                                  _createElementVNode("img", {
                                                                                                    src: _imports_4,
                                                                                                    class: "w-full h-full square-14 img-grey",
                                                                                                    styles: "main-m"
                                                                                                  })
                                                                                                ], -1)),
                                                                                                _createVNode(TextItem, {
                                                                                                  txt: "Marquer en rouge",
                                                                                                  class: "mleft-04",
                                                                                                  styles: "main-m"
                                                                                                })
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1032, ["onClick"]),
                                                                                            _cache[28] || (_cache[28] = _createElementVNode("div", {
                                                                                              class: "line-h",
                                                                                              style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                                                                                            }, null, -1))
                                                                                          ], 64))
                                                                                        : _createCommentVNode("", true),
                                                                                      _createVNode(_component_file_upload, {
                                                                                        id: item3.id.ui,
                                                                                        multiple: "",
                                                                                        onFilesChanged: (files) => handleFiles(files, item1, item2, item3)
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_list_group, {
                                                                                            class: "w-full",
                                                                                            styles: "pad-m"
                                                                                          }, {
                                                                                            default: _withCtx(() => [
                                                                                              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex-square-20 filter-grey" }, [
                                                                                                _createElementVNode("img", {
                                                                                                  src: _imports_5,
                                                                                                  alt: "paperclip",
                                                                                                  class: "w-full h-full square-14"
                                                                                                })
                                                                                              ], -1)),
                                                                                              _createVNode(TextItem, {
                                                                                                txt: "Rajouter fichier(s)",
                                                                                                class: "mleft-04",
                                                                                                styles: "main-m"
                                                                                              })
                                                                                            ]),
                                                                                            _: 1
                                                                                          })
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1032, ["id", "onFilesChanged"]),
                                                                                      _cache[31] || (_cache[31] = _createElementVNode("div", {
                                                                                        class: "line-h",
                                                                                        style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                                                                                      }, null, -1)),
                                                                                      _createVNode(_component_list_group, {
                                                                                        class: "w-full",
                                                                                        styles: "pad-m",
                                                                                        onClick: ($event: any) => (deleteFct(item2, item3))
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createElementVNode("div", null, [
                                                                                            _createVNode(_component_svg_item, {
                                                                                              icon: "trash",
                                                                                              styles: "size-m main-l",
                                                                                              style: {"margin-top":"-0.1rem"}
                                                                                            })
                                                                                          ]),
                                                                                          _createVNode(TextItem, {
                                                                                            txt: "Supprimer",
                                                                                            class: "mleft-04",
                                                                                            styles: "main-m"
                                                                                          })
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1032, ["onClick"]),
                                                                                      (_unref(currentEntryStore).showAnnotations)
                                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                            _cache[30] || (_cache[30] = _createElementVNode("div", {
                                                                                              class: "line-h",
                                                                                              style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                                                                                            }, null, -1)),
                                                                                            _createVNode(_component_list_group, {
                                                                                              class: "w-full",
                                                                                              styles: "pad-m",
                                                                                              onClick: ($event: any) => (dropd.value = 'lBarCsShowAnnotations' + item3.id.ui)
                                                                                            }, {
                                                                                              default: _withCtx(() => [
                                                                                                _createElementVNode("div", null, [
                                                                                                  _createVNode(_component_svg_item, {
                                                                                                    icon: "lightning",
                                                                                                    styles: "size-m main-m"
                                                                                                  })
                                                                                                ]),
                                                                                                _createVNode(TextItem, {
                                                                                                  txt: "NLP",
                                                                                                  class: "mleft-04",
                                                                                                  styles: "main-m"
                                                                                                })
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1032, ["onClick"])
                                                                                          ], 64))
                                                                                        : _createCommentVNode("", true)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ])
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["modelValue", "openOn"]),
                                                                            _createVNode(_component_dropdownBox, {
                                                                              modelValue: dropd.value,
                                                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dropd).value = $event)),
                                                                              openOn: 'lBarCsShowAnnotations' + item3.id.ui
                                                                            }, {
                                                                              dropd: _withCtx(() => [
                                                                                _createVNode(showAnnotations, {
                                                                                  content: item3.expression
                                                                                }, null, 8, ["content"])
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["modelValue", "openOn"])
                                                                          ], 64))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            _createElementVNode("p", _hoisted_45, [
                                                                              (item3.buttonMatched && item1.relationshipId !== currEntryId.value && _unref(isForeignLang)(item3, sctLanguage.value))
                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                                                                    _cache[32] || (_cache[32] = _createElementVNode("img", {
                                                                                      src: _imports_6,
                                                                                      alt: ""
                                                                                    }, null, -1)),
                                                                                    _createTextVNode(" " + _toDisplayString(item3.buttonText), 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              _createTextVNode(" " + _toDisplayString(item3.text), 1)
                                                                            ]),
                                                                            (item3.expression.isCorrected)
                                                                              ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                                                                  key: 0,
                                                                                  modelValue: dropd.value,
                                                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
                                                                                  openOn: 'lBarCsCorrected' + item3.id.ui
                                                                                }, {
                                                                                  dropd: _withCtx(() => [
                                                                                    _createVNode(editExpressionHistory, {
                                                                                      expression: item3.expression,
                                                                                      entry: item1
                                                                                    }, null, 8, ["expression", "entry"])
                                                                                  ]),
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_buttonGroup, { class: "events-1" }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(TextItem, {
                                                                                          txt: _unref(t)('patient.expression.isCorrected'),
                                                                                          styles: "font-s main-l"
                                                                                        }, null, 8, ["txt"])
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1032, ["modelValue", "openOn"]))
                                                                              : _createCommentVNode("", true),
                                                                            (item3.text && _unref(currentEntryStore).isEditable && !_unref(currentEntryStore).currentEntry.archivedByUser)
                                                                              ? (_openBlock(), _createBlock(rBarMoreMenu, {
                                                                                  key: 1,
                                                                                  expr: item3.expression,
                                                                                  class: "events-1 mleft-auto",
                                                                                  isRightBar: false
                                                                                }, null, 8, ["expr"]))
                                                                              : _createCommentVNode("", true)
                                                                          ], 64))
                                                                    ])
                                                                  ], 2)
                                                                ])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128))
                                            ], 2),
                                            (index === item1.conclusionGroups.length -1 && isItem1Editable(item1))
                                              ? (_openBlock(), _createBlock(EsButtonIcon, {
                                                  key: 1,
                                                  tabindex: "-1",
                                                  class: "pad-xl plus-button",
                                                  styles: "icon-grey-style",
                                                  icon: "plus",
                                                  folder: "shareIcons",
                                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (insertCclGroupFct()))
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 4))
                                        : _createCommentVNode("", true),
                                      (!_unref(uiStore).resultFilter && isCclVisible(item1, item2))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (item2.groupOrder > 0)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  style: _normalizeStyle({'grid-row': item2.row}),
                                                  class: "col es-conclusion-arrow"
                                                }, _cache[33] || (_cache[33] = [
                                                  _createElementVNode("div", { class: "row-start h-full w-full mtop-20" }, [
                                                    _createElementVNode("img", {
                                                      src: _imports_1,
                                                      class: "square-14"
                                                    })
                                                  ], -1)
                                                ]), 4))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                              style: _normalizeStyle({'grid-row': item2.row}),
                                              class: "col mleft-10 es-prescription"
                                            }, [
                                              (item2.groupOrder === 0 && hasCclContent(item1.conclusionGroups[0]))
                                                ? (_openBlock(), _createBlock(EsConsultationTopBar, {
                                                    key: 0,
                                                    templateDocArr: item1.conclusionGroups[0].templateDocArr ?? [],
                                                    sapExprArr: item1.conclusionGroups[0].sapExprArr ?? [],
                                                    bioPrescrArr: item1.conclusionGroups[0].bioPrescrArr ?? []
                                                  }, null, 8, ["templateDocArr", "sapExprArr", "bioPrescrArr"]))
                                                : (item2.groupOrder > 0)
                                                  ? (_openBlock(), _createBlock(groupCcl, {
                                                      key: 1,
                                                      isCurrentCs: isItem1Editable(item1),
                                                      isExpanded: expandedARR.includes(item1.id.ui),
                                                      item1: item1,
                                                      item2: item2,
                                                      item3: (item2.row > 1) ? item2.resultsArr.at(-1) : null,
                                                      onDisplayTemplateDocArr: _cache[14] || (_cache[14] = ($event: any) => (templateDocArr.value = $event)),
                                                      onDisplaySapExprArr: _cache[15] || (_cache[15] = ($event: any) => (sapExprArr.value = $event))
                                                    }, null, 8, ["isCurrentCs", "isExpanded", "item1", "item2", "item3"]))
                                                  : _createCommentVNode("", true)
                                            ], 4)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_8))
              }), 128)),
              (csListLoading.value && canLoadMoreCs.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(loadingSpinner, { logo: false }),
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('common.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              ((!_unref(currentEntryStore).isEditable && !_unref(currentEntryStore).hasCurrentEntry) || (_unref(currentEntryStore).csList.length == 0 && areFiltersActive.value && !csListLoading.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _cache[34] || (_cache[34] = _createElementVNode("img", {
                      class: "h-48 img-grey",
                      src: _imports_0
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(t)('patient.no_entry')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                ref_key: "infiniteScrollTrigger",
                ref: infiniteScrollTrigger,
                style: {"height":"30px"}
              }, null, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(middleColumn)
          ])
        ])),
    _createVNode(EsSelectHealthProDelegateModal, {
      "is-open": openSelectHealthProDelegate.value,
      "health-pro-delegate": _unref(appUserStore).healthProDelegate,
      onModalClose: _cache[16] || (_cache[16] = ($event: any) => (closeSelectHealthProDelegateModal($event)))
    }, null, 8, ["is-open", "health-pro-delegate"]),
    _createVNode(EsConfirmDialog, {
      isOpen: isArchiveRestoreModalOpen.value,
      header: confirmHeader.value,
      message: confirmMessage.value,
      "on-confirm": () => closeConfirmArchiveRestoreEntryModal(true),
      onModalClose: _cache[17] || (_cache[17] = () => closeConfirmArchiveRestoreEntryModal(false))
    }, null, 8, ["isOpen", "header", "message", "on-confirm"])
  ], 64))
}
}

})